import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editarSelectedMcp } from '../features/map/selectedMcpSlice';
import { RootState } from '../store';

function Details(){
  const municipios = useSelector((state: RootState) => state.map)
  const selectedMcp = useSelector((state: RootState) => state.selectedMcp)
  const dispatch = useDispatch()

  function handleChange(event){
    dispatch(editarSelectedMcp( event.target.value ))
  }
 
  return (
  <div className='details-container'>
    <header>Estado del Municipio</header>
    <div>
      <section>
        <select 
          id="municipio"
          value={selectedMcp}
          onChange={handleChange}
          name="municipio"
          >
          <option value=""></option>
          {
              municipios.items.map((item) =>(
                  <option key={item.id} value={item.name}>{item.name}</option>
              ))
          }        
        </select>
      </section>
      <section>
        {(selectedMcp && municipios.items.length > 0) && <span>
          <section>
            <b>{selectedMcp ? municipios.items.find(m => m.name === selectedMcp)?.reports.length : 0}</b>
            <a>Reportes en el día de hoy</a>
          </section>
        </span>}
      </section>
      <section>
        {
          municipios.items.find(m => m.name === selectedMcp)?.reports.map((reporte, index) => (
            <span key={`${reporte.deviceId}-${index}`} className='reporte'>
              <i>{reporte.location}</i>
              {reporte.mediaLink && (
                <a href={reporte.mediaLink} target="_blank" rel="noopener noreferrer">
                  <button className='small-button'>Imágenes</button>
                </a>
              )}
            </span>
          ))
        }
      </section>
    </div>      
  </div>
  )
}

export default Details;